module.exports = __webpack_public_path__ + "static/media/shopbag_new.b0a7d984.svg";